<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="dateRange" label="检测日期">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button :loading="exportLoading" type="primary" @click="handleExport">导出</el-button>
      </TableHeader>

      <el-table v-loading="tableLoading" ref="table" :data="tableData" border stripe height="100%">
        <el-table-column prop="name" label="姓名" width="160" align="center"></el-table-column>
        <el-table-column prop="bzCnt" label="编制报告数量" align="center"></el-table-column>
        <el-table-column prop="auditeCnt" label="审核报告数量" align="center"></el-table-column>
        <el-table-column prop="approveCnt" label="批准报告数量" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import modal from '@/utils/modal';

import TableHeader from '@/components/TableHeader';

import { getCheckStat } from '@/api/flow';

export default {
  components: { TableHeader },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 9999,
        dateRange: []
      },
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      editVisible: false,
      activeRows: [],
      batchNoVisible: false,
      exportLoading: false
    };
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getCheckStat({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];

      this.tableLoading = false;

      this.$nextTick(() => {
        this.$refs.table.doLayout(); // 重置表格布局
      });
    },
    async handleExport() {
      modal.loading('数据导出中...');
      const { export_json_to_excel } = require('@/excel/Export2Excel.js'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getCheckStat({ ...this.searchModel, startTime, endTime, pageSize: 99999 });
      const exportTableData = data.list || [];
      exportTableData.map((item, index) => {
        item.tableNo = index + 1;
        item.bzCnt = item.bzCnt || '0';
        item.auditeCnt = item.auditeCnt || '0';
        item.approveCnt = item.approveCnt || '0';
      });

      const filename = `试验统计-系统导出${startDate}~${endDate}`;
      const tHeader = ['序号'];
      const filterVal = ['tableNo'];
      const excelColmn1 = [`试验统计-系统导出${startDate}~${endDate}`];

      const columns = this.$refs.table.columns;
      columns.forEach(column => {
        if (column.label == '序号' || column.label == '操作') return;
        tHeader.push(column.label);
        filterVal.push(column.property);
        excelColmn1.push('');
      });

      const multiHeader = [excelColmn1]; // 标题

      const formatData = this.formatJson(filterVal, exportTableData);

      const merges = this.getMerges(excelColmn1.length); //需要合并的单元格

      export_json_to_excel(tHeader, formatData, filename, multiHeader, merges);
      modal.closeLoading();
    },
    getMerges(mergesLen) {
      let merges = '';
      for (let i = 0; i < mergesLen; i++) {
        const str = String.fromCharCode(65 + i) + '1:';
        merges += str;
      }

      return [merges.slice(0, -1)];
    },
    /**
     * 格式转换
     * @param filterVal
     * @param jsonData
     * @returns {*}
     */
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  },
  mounted() {
    // 默认当前月份的日期
    this.searchModel.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')];
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.link-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
